/**
 * Token-based fuzzy match.
 * Splits query by spaces; every token must be found (case-insensitive includes)
 * in at least one of the target fields.
 * Returns true if all tokens match, false otherwise.
 */
export const fuzzyMatch = (query, ...fields) => {
  if (!query) return false;
  const tokens = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return false;
  const haystack = fields.filter(Boolean).map(String).join(" ").toLowerCase();
  return tokens.every((t) => haystack.includes(t));
};